import React, { useState } from 'react';
import { BasicContainer, BodyTextSmall, FlexRow, ImageButton } from '@minecraft.atoms';
import Icon from '@minecraft.icon';
import { useTranslation } from '@blocs.i18n';
import { FeatureList } from '../PlanSelection/FeatureList';
import { PlanType } from '../usePlans';
import { PlanFeatureType } from '../features';

export const PlanExplorer: React.FC<{
  selectedPlan: PlanType;
  customFeatures?: PlanFeatureType[];
  ctaText?: string;
}> = ({ selectedPlan, customFeatures, ctaText }) => {
  const [isShown, setIsShown] = useState(false);
  const { t } = useTranslation();
  const exploreFeaturesText = ctaText || t('common:paywall.plan.features.exploreAdditionalFeatures');

  return (
    <>
      <ImageButton onClick={() => setIsShown(!isShown)} unsetSizing>
        <FlexRow
          w="fit"
          justifyContent="center"
          alignItems="center"
          className="cn_atom_py-2 cn_atom_px-5"
          bgColor="vanillaPaywallDarkBg"
          borderRadius="3xl"
          gap="3"
          mt="2"
          mb="4"
        >
          <BodyTextSmall fontWeight="medium">
            {isShown ? t('common:paywall.plan.features.hideFeatures') : exploreFeaturesText}
          </BodyTextSmall>
          <Icon name={isShown ? 'chevron-open-thick' : 'chevron-closed-thick'} size="ssm" />
        </FlexRow>
      </ImageButton>
      {isShown && (
        <BasicContainer w="full" data-testid="plan-features-list">
          <FeatureList
            isFullFeatureList
            temperature={selectedPlan?.temperature}
            features={customFeatures || selectedPlan?.features}
          />
        </BasicContainer>
      )}
    </>
  );
};
